import CustomButton from "common/components/Button/Button"
import createImgURI from "common/utils/createImgURI"
import { motion } from "framer-motion"
import { Button } from "primereact/button"
import { useDropzone } from "react-dropzone"
import "./imagePreview.scss"

const actionsVariants = {
  hidden: {
    opacity: 0,
  },
  hover: {
    opacity: 1,
    trasition: {
      type: "tween",
    },
  },
}

const backgroundVariants = {
  hidden: {
    opacity: 0,
  },
  hover: {
    opacity: 1,
    backgroundColor: "rgba(0, 0, 0, 0.10)",
    trasition: {
      type: "tween",
    },
  },
}

const TWO_MB = 2097152

const ImagePreview = ({
  image,
  imagenBase64,
  imagenMediaType,
  setImage,
  deleteImage,
}: $TSMigrationFixMe) => {
  const onDrop = (files: $TSMigrationFixMe) => {
    setImage(files[0])
  }

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    maxFiles: 1,
    maxSize: TWO_MB,
    accept: "image/*",
  })

  if (!image && !imagenBase64) return null

  const imageSrc = image
    ? URL.createObjectURL(image)
    : createImgURI(imagenBase64, imagenMediaType)

  return (
    // @ts-expect-error TS(2322): Type '{ children: Element[]; refKey?: string | und...
    <motion.div
      whileHover='hover'
      initial='hidden'
      className='image-preview-wrap'
      {...getRootProps()}
    >
      <img
        className='img-preview'
        src={imageSrc}
        alt='Imagen de la categoría'
      />

      <motion.div
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          deleteImage()
        }}
        variants={actionsVariants}
        className='wrap-delete-image-preview'
      >
        <Button
          type='button'
          icon='pi pi-times'
          className='p-button-danger'
        />
      </motion.div>

      <motion.div
        className='background-image-preview'
        variants={backgroundVariants}
      />

      <motion.div
        variants={actionsVariants}
        className='wrap-action-image-preview'
      >
        <CustomButton
          type='button'
          className='outlined'
          label='Cambiar'
        >
          <input {...getInputProps()} />
        </CustomButton>
      </motion.div>
    </motion.div>
  )
}

export default ImagePreview
